import "./componentCss/login.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "./componentCss/background.css";

function RotatingImages({ images, currentImage }) {
  return (
    <div className="position-relative" style={{ height: "100%", width: "100%" }}>
      {images.map((image, index) => (
        <img key={index} src={image} className={`img-fluid position-absolute w-100 h-100 transition-opacity ${currentImage === index + 1 ? "opacity-1" : "opacity-0" }`} alt={`Slide ${index + 1}`} style={{ transition: "opacity 1s ease-in-out" }} />
      ))}
    </div>
  );
}
function Login() {
  const [currentImage, setCurrentImage] = useState(1);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [showPass, setShowPasss] = useState(false)
  const totalImages = 4;
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev === totalImages ? 1 : prev + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [totalImages]);
  useEffect(() => {
    const cookies = document.cookie;
    if (cookies.split("; ").find((cookie) => cookie.startsWith("user"))) {
      document.cookie = "user=; max-age=0; path=/;";
    }
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    name === "username" ? setUsername(value) : setPassword(value);
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!username || !password) {
    toast.error("Username and password are required");
    return;
  }

  try {
  const response = await axios.post(`https://node.cabletvpay.in/login`, {
    username,
    password,
  });

if (response.status === 200) {
  const { user, opt, role, access, redirect, isStaff, secret_id } = response.data;

  document.cookie = `user=${user}; path=/`;
  document.cookie = `opt=${opt}; path=/`;
  document.cookie = `isStaff=${isStaff}; path=/`;

  if (isStaff && secret_id) {
    document.cookie = `secretId=${secret_id}; path=/`;
  }

  toast.success("Login successful");

  if (isStaff) {
    // 🔥 FIXED
    setTimeout(() => navigate("/allCustomer/all"), 100);

  } else if (role) {
    setTimeout(() => navigate("/adminHome"), 100);

  } else {
    const redirectPath = redirect === "home" ? "/home" : "/BillPayment";
    setTimeout(() => navigate(redirectPath), 100);
  }
}
} catch (error) {
  toast.error(error.response?.data?.message || "Login failed");
} 
};
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 min-vw-100 p-0">
      <img src="../asset/img/cableTv.png" alt="Flying TV" className="tv-image" />
      <div className="d-flex justify-content-center bg-light shadow-lg m-0 p-0">
        <div className="login-box d-flex justify-content-center align-items-center min-vh-50">
          <div className="px-2">
            <div className="d-flex justify-content-center card-header mt-2 mb-0 py-0 mx-3">
              <h4 className="py-0">
                <b className="h3 mt-0 pt-0 text-purple text-bold">CableTvPay</b>login
              </h4>
            </div>
            <div className="card-body mb-lg-4">
              <p className="login-box-msg text-muted mx-0 px-0 text-center mb-lg-2">Cable collection administration</p>
              <form className="mb-lg-5" onSubmit={handleSubmit}>
                <div className="input-group mb-3 mt-1 border-0 elevation-1">
                  <input type="text" className="form-control loginInput text-navy border-0" placeholder="Username" id="username" name="username" value={username} onChange={handleInputChange} required style={{ borderRight: "none", backgroundColor:"rgb(232, 240, 255)" }} aria-label="Username" />
                  <div className="input-group-append">
                    <div className="input-group-text border-0" style={{backgroundColor:"rgb(232, 240, 255)"}}>
                      <span className="fas fa-user text-navy bg-white" />
                    </div>
                  </div>
                </div>
                <div className="input-group mb-3 border-0 elevation-1">
                  <input type={showPass ? 'text' : 'password'} className="form-control loginInput text-navy border-0" placeholder="Password" id="password" name="password" value={password} onChange={handleInputChange} required style={{ borderRight: "none", backgroundColor:"rgb(232, 240, 255)" }} aria-label="Password" />
                  <div className="input-group-append">
                    <div className="input-group-text border-0" style={{backgroundColor:"rgb(232, 240, 255)"}}>
                      <span className="fas fa-lock text-navy bg-white" />
                    </div>
                  </div>
                </div>
                <div className="d-flex ml-1">
                  <input type="checkbox" className="border-secondary" name="showPassword" id="showPassword" onChange={(e) => {setShowPasss(!showPass);
                  }} />
                  <label htmlFor="showPassword">&nbsp; Show Password</label>
                </div>
                <div className="row">
                  <div className="col-12 py-1">
                    <button type="submit" className="form-control btn bg-gradient-purple btn-block elevation-2" > Log In </button>
                  </div>
                </div>
              </form>
              <div className="pb-0 mt-4 d-flex justify-content-center">
                <p className="login-box-msg text-muted">Login to Unlock Hassle-Free Application</p>
              </div>
            </div>
          </div>
        </div>
        <div className="imgs m-0" style={{ height: "450px", width: "450px" }}>
          <RotatingImages
            images={["/asset/img/login2.svg","/asset/img/login2.jpg","/asset/img/login3.jpg","/asset/img/login2.jpg",]}
            currentImage={currentImage}
          />
        </div>
      </div>
      <div style={{ position: "absolute", top: "30px" }}><ToastContainer /></div>
    </div>
  );
}
export default Login;